import { render, staticRenderFns } from "./ClassGroupCompetitionConfig.vue?vue&type=template&id=f4dc334c&scoped=true"
import script from "./ClassGroupCompetitionConfig.vue?vue&type=script&lang=js"
export * from "./ClassGroupCompetitionConfig.vue?vue&type=script&lang=js"
import style0 from "./ClassGroupCompetitionConfig.vue?vue&type=style&index=0&id=f4dc334c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dc334c",
  null
  
)

export default component.exports